<template>
  <span class="wf-crumb">
    <span v-if="exhibitName" class="wf-crumb__exhibit">{{ exhibitName }} : </span>
    <template v-for="(step, i) in steps" :key="step.key">
      <span
        :class="['wf-crumb__step', step.key === current ? 'wf-crumb__step--current' : 'wf-crumb__step--link']"
        @click="onClick(step)"
      >{{ step.label }}</span><span v-if="i < steps.length - 1" class="wf-crumb__sep"> › </span>
    </template>
  </span>
</template>

<script>
import { computed } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";

export default {
  name: "WorkflowBreadcrumb",
  props: {
    // Clé de l'étape courante : 'exhibits' | 'home' | 'navigation' | 'intermediate' | 'associate'
    current: { type: String, required: true },
    exhibitName: { type: String, default: "" },
  },
  setup(props) {
    const router = useRouter();
    const store = useStore();

    // Workflow complet (branche « carte interactive » / template_6), dans l'ordre.
    const steps = computed(() => [
      { key: "exhibits", label: "Retour aux expositions", path: "/admin" },
      { key: "home", label: "Créer la page d'accueil", path: `/expo/${store.state.exhibitId}` },
      { key: "navigation", label: "Concevoir la navigation", path: "/point" },
      { key: "intermediate", label: "Créer une page intermédiaire", path: "/resourceManagement" },
      { key: "associate", label: "Associer des objets", path: "/associationManagement" },
    ]);

    const onClick = (step) => {
      // Toutes les étapes sont cliquables sauf l'étape courante.
      if (step.key === props.current) return;
      router.push(step.path);
    };

    return { steps, onClick };
  },
};
</script>

<style scoped>
.wf-crumb__exhibit {
  cursor: default;
}
.wf-crumb__step--link {
  font-style: italic;
  cursor: pointer;
}
.wf-crumb__step--link:hover {
  text-decoration: underline;
}
.wf-crumb__step--current {
  font-weight: 700;
}
.wf-crumb__sep {
  font-style: italic;
}
</style>
